// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_sw-5";
export var filledCircle = "_sw-4";
export var historyEntry = "_sw-3";
export var messageSideLeft = "_sw-1";
export var messageSideRight = "_sw-2";
export var orderTrackingCarouselWrapper = "_sw-6";
export var orderTrackingInfoContainer = "_sw-0";